import React, { useState, useEffect } from 'react'
import { makeStyles, Typography, Button } from '@material-ui/core'
import Logger from 'js-logger';

import Minimax from 'tic-tac-toe-minimax';

const useStyles = makeStyles(theme=>({
	container:{
		display:'flex',
		flexDirection:'column',
	},
	position:{
		flex:1,
		margin:'5px',
		marginLeft:'0px',
		minWidth:'95px',
		minHeight:'95px',
		backgroundColor:theme.palette.background.paper,
		cursor:'pointer',
	},
	positionSelected:{
		flex:1,
		margin:'5px',
		marginLeft:'0px',
		minWidth:'95px',
		minHeight:'95px',
		backgroundColor:theme.palette.background.default,
		display:'flex',
		justifyContent:'center',
		alignItems:'center',
	},
	gamerow:{
		flex:1,
	},
	gameboard:{
		display:'flex',
	},
	controls:{
		display:'flex',
		justifyContent:'center',
	},
	header:{
		display:'flex',
		justifyContent:'center',
	}
}));

const checker = [
	//rows
	[0,1,2],
	[3,4,5],
	[6,7,8],
	//columns
	[0,3,6],
	[1,4,7],
	[2,5,8],
	// 'x'
	[0,4,8],
	[6,4,2]
];

const isGameOver = (b) => checker.some(i => b[i[0]] === b[i[1]] && b[i[1]] === b[i[2]]);
const isGameDraw = (b) => !b.some(i => typeof i === 'number');

const GamePosition = ({id,label,onClick}) => {
	
	const classes = useStyles();

	const square = typeof label === 'string' ? 
		<div key={id} className={classes.positionSelected}>
			<Typography variant="h2" >
				{label}
			</Typography>
		</div>
		:
		<div key={id} className={classes.position} onClick={onClick} />
	
	return (
		<>
			{square}
		</>
	)
};

const P1 = 'X';
const P2 = 'O';

const symbols = {
	huPlayer: 'X',
	aiPlayer: 'O'
};

const TicTacToe = ({onGame}) => {
	const classes = useStyles();

	const [gameWon,setGameWon] = useState(false);
	const [gameDraw,setGameDraw] = useState(false);
	const [currentPlayer,setCurrentPlayer] = useState(P1);
	const [board,setBoard] = useState([0,1,2,3,4,5,6,7,8]);
	const [gameMoves,setGameMoves] = useState([]);

	const uiClick = (index) => {
		if(currentPlayer === P2 || gameWon) return;

		const b = [...board];
		b[index] = P1;

		setBoard(b);
		setCurrentPlayer(P2);
	};

	const onReset = () => {
		setBoard([0,1,2,3,4,5,6,7,8]);
		setGameWon(false);
		setGameDraw(false);
		Logger.info(gameMoves);
		onGame([...gameMoves]);
		setGameMoves([]);
		setCurrentPlayer(P1);
	};

	useEffect(() =>{
		const gm = [...gameMoves];
		gm.push(board);

		setGameMoves(gm);
		setGameWon(isGameOver(board));
		setGameDraw(isGameDraw(board));
	// eslint-disable-next-line react-hooks/exhaustive-deps
	},[board]);

	useEffect(() =>{
		if( currentPlayer === P1 || isGameOver(board) || isGameDraw(board)) return;
		const difficulty = "Normal";
		const {ComputerMove} = Minimax;
		
		const index = ComputerMove( board, symbols, difficulty );

		if(isNaN(index)) return;

		const b = [...board];
		b[index] = P2;
		setBoard(b);
		setCurrentPlayer(P1);

	},[board]);

	return (
		<div className={classes.container}>
			<div className={classes.header}>
				{gameWon &&
					<Typography variant="h5" >
						GAME OVER
					</Typography>
				}{gameDraw && !gameWon &&
					<Typography variant="h5" >
						DRAW
					</Typography>
				}
			</div>
			<div className={classes.gameboard}>
				<div>
					<GamePosition id={0} label={board[0]} onClick={() => uiClick(0)} />
					<GamePosition id={1} label={board[1]} onClick={() => uiClick(1)} />
					<GamePosition id={2} label={board[2]} onClick={() => uiClick(2)} />
				</div>
				<div>
					<GamePosition id={3} label={board[3]} onClick={() => uiClick(3)} />
					<GamePosition id={4} label={board[4]} onClick={() => uiClick(4)} />
					<GamePosition id={5} label={board[5]} onClick={() => uiClick(5)} />
				</div>
				<div>
					<GamePosition id={6} label={board[6]} onClick={() => uiClick(6)} />
					<GamePosition id={7} label={board[7]} onClick={() => uiClick(7)} />
					<GamePosition id={8} label={board[8]} onClick={() => uiClick(8)} />
				</div>
			</div>
			<div className={classes.controls}>
				<Button variant="outlined" size="small" onClick={onReset}>reset</Button>
			</div>
		</div>
	);
};

export default TicTacToe;
